import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import MenuList from '../components/MenuList';
import MenuDetails from '../components/MenuDetails';
import DailyMenuPdf from '../components/DailyMenuPdf';
import '../styles/Menu.css';
import BackgroundShader from '../components/BackgroundShader';

const Home = () => {
  const [allMenus, setAllMenus] = useState([]);
  const [menus, setMenus] = useState([]);
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const BASE_URL = process.env.REACT_APP_API_URL;
  console.log(process.env.REACT_APP_API_URL);

  useEffect(() => {
    const fetchMenus = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/ilrialto/menus/dujour`);	
        const data = response.data;

        setAllMenus(data);

        const uniqueCategories = [...new Set(data.map(menu => menu.category_name))];
        setCategories(uniqueCategories);

        if (uniqueCategories.length > 0) {
          const firstCategory = uniqueCategories[0];
          setCategory(firstCategory);

          const filtered = data.filter(menu => menu.category_name === firstCategory);
          setMenus(filtered);
          setSelectedMenu(filtered[0]);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des menus:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchMenus();
  }, []);

  useEffect(() => {
    if (!category) return;
    const filtered = allMenus.filter(menu => menu.category_name === category);
    setMenus(filtered);
    setSelectedMenu(filtered[0]);
  }, [category, allMenus]);

  const handleCategoryChange = (newCategory) => {
    setShowSuggestions(false); // reviens au menu normal
    setCategory(newCategory);
  };

  const handleMenuClick = (menu) => {
    setSelectedMenu(menu);
  };

  const handleShowSuggestions = () => {
    setShowSuggestions(true);
  };

  const handleHideSuggestions = () => {
    setShowSuggestions(false);
  };

  return (
    <div className="home-container">
      <Sidebar
        categories={categories}
        onCategoryChange={handleCategoryChange}
        activeCategory={category}
        onShowSuggestions={handleShowSuggestions}
        showSuggestions={showSuggestions} 
      />
      <BackgroundShader/>

      <div className="menu-container">
        {isLoading ? (
          <div className="loading-indicator">Chargement...</div>
        ) : showSuggestions ? (
          <>
            {/* <button className="btn-retour" onClick={handleHideSuggestions}>← Retour au menu</button> */}
            <DailyMenuPdf menus={allMenus} />
          </>
        ) : (
          <>
            <MenuList
              menus={menus}
              onMenuClick={handleMenuClick}
              selectedMenu={selectedMenu}
            />
            <MenuDetails menu={selectedMenu} />
          </>
        )}
      </div>
    </div>
  );
};

export default Home;
